module.exports = "/static/images/NC_foothills_logo.png";